export const placeTypes = [
  "Continent",
  "Region",
  "Country",
  "City",
  "Neighborhood",
];

export const pluralizedPlaceTypes = {
  continent: "continents",
  region: "regions",
  country: "countries",
  city: "cities",
  neighborhood: "neighborhoods",
};

export const placeSortOptions = ["DESC", "ALPHA_ASC", "ALPHA_DESC"];

export const placeSortDescriptions = {
  ALPHA_ASC: "A - Z",
  ALPHA_DESC: "Z - A",
  DESC: "Most Popular",
};
